import WidgetComponent from './widgetComponent'
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import context from '@/context'
import { actionCreators } from '@/store/Notifications'
import WidgetContent from '@/components/notifications/widgetContent'
import Resx from '@/components/Resx'

@connect((state) => ({ componentKey: state.notifications.widgetKey }), { updateState: actionCreators.updateState })
class NotificationsWidget extends WidgetComponent {
  componentKey () { return this.props.componentKey }
  headerButtons () { return <Link to='/notifications'><Resx name='Common.More' /></Link> }
  widgetIcon () { return 'bell' }
  widgetTitleKey () { return 'NotificationsUI.WidgetTitle' }
  dataSource () { return context.api.notificationService.getNotifications(undefined, 0, this.props.widgetItem.rowsCount) }
  renderContent (data) { return <WidgetContent items={data.notifications} updateState={this.props.updateState} /> }
}

export {
  NotificationsWidget
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/notifications.js